import type { ComponentType, SVGProps } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { BasilHome, BasilMessageCircle, BasilShoppingBag, BasilTrophy, BasilUser } from "@/components/icons/basil";
import { useMissions } from "@/lib/renewal/missions";
import { cn } from "@shared/lib/utils";

type TabItem = { label: string; icon: ComponentType<SVGProps<SVGSVGElement>>; to: string };

/** 모바일 1차 내비 5탭 — Missions·Cards는 /profile 허브로 이동(라우트는 유지), 44px 타깃. */
const TABS: TabItem[] = [
  { label: "Home", icon: BasilHome, to: "/home" },
  { label: "Shop", icon: BasilShoppingBag, to: "/shop" },
  { label: "Season", icon: BasilTrophy, to: "/season" },
  { label: "Agents", icon: BasilMessageCircle, to: "/agents" },
  { label: "Profile", icon: BasilUser, to: "/profile" },
];

export function MobileTabBar() {
  const { missions } = useMissions();
  const claimable = missions.filter((mission) => mission.status === "claimable").length;
  // /cards/*는 컬렉션 상세 계열 — Profile 탭 활성으로 위치 감각 유지(improvements §M-23)
  const { pathname } = useLocation();
  return (
    <nav
      aria-label="Primary"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-line bg-(--ty-bg-2) pb-[env(safe-area-inset-bottom)] lg:hidden"
    >
      <ul className="mx-auto flex max-w-md items-stretch">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          return (
            <li key={tab.to} className="flex-1">
              <NavLink
                to={tab.to}
                end={tab.to === "/home"}
                className={({ isActive }) =>
                  cn(
                    "flex min-h-[52px] flex-col items-center justify-center gap-0.5 py-1.5",
                    isActive || (tab.to === "/profile" && pathname.startsWith("/cards"))
                      ? "text-accent"
                      : "text-ink-mute",
                  )
                }
              >
                <span className="relative">
                  <Icon className="size-5" aria-hidden />
                  {tab.to === "/profile" && claimable > 0 && (
                    <span
                      aria-hidden
                      className="absolute -right-1 -top-0.5 size-1.5 rounded-full bg-danger"
                    />
                  )}
                </span>
                <span className="font-mono text-[9px] font-medium uppercase tracking-[0.1em]">
                  {tab.label}
                </span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
